import { createApi } from "../../utils/createApi";
import { useAppStore } from "../../../appStore";

const apiResources = [
  [`group/?page_size=2027`, "groupArray"],
  [`group/tree/?group_type=connector&page_size=1000`, "groupTrees"],
  [`group/?page_size=10000`, "parentGroups"],
];

async function getResource(resource: string[]) {
  const AxiosUI = createApi(``);
  const { data } = await AxiosUI.get(resource[0]);
  if (resource[1] === "groupTrees") {
    useAppStore.getState().setGroupTrees(data.results);
  } else {
    localStorage.setItem(`${resource[1]}`, JSON.stringify(data.results));
  }
}

export async function getUpdatedSitesPageInfo() {
  const apiPromises = apiResources.map(getResource);
  await Promise.all(apiPromises);
}
